// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TaxRequestsController = function ($scope, taxRequestsService, $routeParams) {

    $scope.updateFilters = function () {
        var setDefaultDetails = function (result) {
            if (result && result.length > 0) {
                $scope.showDetails(result[0].Id);
            }
        };

        $scope.taxRequests = $scope.paginator(function (options, callback) {
            return taxRequestsService.query(options,
                function (result) {
                    callback();
                    setDefaultDetails(result);
                    $scope.wasSearching = options.search;
                });
        }, {}, 20);
    };

    $scope.showDetails = function (id) {
        $scope.loadingDetails = true;
        $scope.selectedTaxRequest = taxRequestsService.get({ taxRequestId: id }, function () {
            $scope.loadingDetails = false;
        });
    }

    function init() {
        $scope.selectedTaxRequest = undefined;
        $scope.loadingDetails = false;

        if ($routeParams.filter) {
            $scope.search = $routeParams.filter;
        }
        $scope.updateFilters();
    }
    init();
}; 

TaxRequestsController.$inject = ['$scope', 'TaxRequests', '$routeParams'];
